<section
  class="custom-sign-up"
  fxLayout.mm-mobile="column"
  fxLayout.mm-tablet="column"
  [fxLayout]="'row wrap'"
  fxLayoutGap.mm-mobile="19px"
>
  <figure class="custom-sign-up__imgcontainer">
    <img
      *ngIf="imageLeft?.filename"
      class="custom-sign-up__imgcontainer__customImg"
      [appLazyLoadImage]="imageLeft.filename"
      [alt]="imageLeft.alt"
    />
    <img
      *ngIf="!imageLeft?.filename"
      [appLazyLoadImage]="isMobile ? newsLetterImageMobile : newsLetterImage"
      alt="newsletter-image"
    />
  </figure>
  <div class="custom-sign-up__content">
    <ng-container *ngIf="!isFormSubmitted; else submitConfirmationTemplate">
      <p class="custom-sign-up__content__header">
        <span *ngIf="title">{{ title }}</span>
      </p>
      <p class="custom-sign-up__content__subheader">
        <span *ngIf="subTitle">{{ subTitle }}</span>
      </p>
      <form [formGroup]="form" (submit)="onSubmit()" fxLayout="row wrap" fxLayoutGap.mm-tablet="10px">
        <div fxFlex="67%" fxFlex.mm-tablet="65%">
          <mm-field>
            <input
              mmInput
              type="text"
              formControlName="email"
              aria-label="newsletter input for user email addresses"
              placeholder="{{ 'HOME.HOME_PAGE.NEWSLETTER.EMAIL_PLACEHOLDER' | translate }}"
            />
          </mm-field>
          <mm-error fieldName="email">
            {{ 'CATALOG.DETAILS_PAGE.BUYBOX.OUT_OF_STOCK.VALIDATION' | translate }}
          </mm-error>
        </div>
        <div fxFlex="33%">
          <button
            mm-button
            type="submit"
            class="custom-sign-up__content__button"
            [ngClass]="{ 'custom-sign-up__content__button__active': isLoading }"
            [color]="'primary'"
          >
            <span *ngIf="!isLoading && buttonText">{{ buttonText }}</span>
            <mm-icon name="check" *ngIf="isLoading"></mm-icon>
          </button>
        </div>
      </form>
      <p class="custom-sign-up__content__consent" [innerHTML]="termsAndConditions?.value"></p>
    </ng-container>
  </div>
</section>

<ng-template #submitConfirmationTemplate>
  <ng-container>
    <div class="custom-sign-up__content__confirm">
      <p class="custom-sign-up__content__submit-text" [innerHTML]="confirmationMessage?.value"></p>
    </div>
  </ng-container>
</ng-template>
